import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  height: fit-content;
`;
const SVG = styled.svg `
  margin: 0 auto;
  border-radius: 50%;
  display: block;
`;
const ValueContainer = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -30%);
  display: flex;
  align-items: flex-start;
`;
const SpeedometerChartTrack = styled.circle `
  fill: transparent;
  stroke: ${({ theme }) => theme.greyLightMedium};
  stroke-width: 26;
`;
const SpeedometerChartTrackIndicator = styled.circle `
  fill: transparent;
  stroke: ${({ color, theme }) => (color ? color : theme.primaryRed)};
  stroke-width: 26;
  stroke-dasharray: 0 10000;
  transition: stroke-dasharray 1s ease;
`;
const Value = styled.span `
  font-family: ${({ theme }) => theme.fontFamilyBase};
  color: ${({ theme }) => theme.greyDark};
  font-style: normal;
  font-weight: 500;
  font-size: ${({ customFontSize }) => (customFontSize ? `${customFontSize}px` : '40px')};
  line-height: 30px;
  width: 45px;
  height: 30px;
`;
const Symbol = styled.span `
  font-family: ${({ theme }) => theme.fontFamilyBase};
  color: ${({ theme }) => theme.greyDark};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 18px;
  width: 17px;
  height: 18px;
`;
export const SpeedometerChart = ({ initialValue = 0, newValue = 99, dimensions = 120, strokeWidth = 14, initiateAnimation = false, color = undefined, fontSize = undefined, }) => {
    const [currentValue, setNewValue] = useState(initialValue);
    const updateValueToAnimate = () => setNewValue(newValue);
    useEffect(() => {
        if (initiateAnimation) {
            updateValueToAnimate();
        }
    }, [initiateAnimation]);
    const halfDimensions = dimensions * 0.5;
    const radius = halfDimensions - strokeWidth * 0.5;
    const circumference = 2 * Math.PI * radius;
    const strokeVal = (currentValue * circumference) / 100;
    const dashVal = strokeVal + ' ' + circumference;
    const trackStyle = { strokeWidth: strokeWidth / 2 };
    const indicatorStyle = { strokeWidth: strokeWidth, strokeDasharray: dashVal };
    const rotateVal = 'rotate(-90 ' + halfDimensions + ',' + halfDimensions + ')';
    return (React.createElement(Container, null,
        React.createElement(SVG, { width: dimensions, height: dimensions },
            React.createElement(SpeedometerChartTrack, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: trackStyle, 
                // className convention is used by InfographicContainer styling
                className: "chart-track" }),
            React.createElement(SpeedometerChartTrackIndicator, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: indicatorStyle, color: color, className: "chart-indicator" })),
        React.createElement(ValueContainer, null,
            React.createElement(Value, { customFontSize: fontSize, className: "chart-value" }, newValue.toString()),
            React.createElement(Symbol, { className: "chart-symbol" }, "%"))));
};
